import { render, staticRenderFns } from "./MainCOMUNE.vue?vue&type=template&id=1ef212fd&scoped=true&"
import script from "./MainCOMUNE.vue?vue&type=script&lang=ts&"
export * from "./MainCOMUNE.vue?vue&type=script&lang=ts&"
import style0 from "./MainCOMUNE.vue?vue&type=style&index=0&id=1ef212fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef212fd",
  null
  
)

export default component.exports